module.exports = __webpack_public_path__ + "static/img/playerData.421cfb14.svg";